import {
  INSERE_DADOS,
  CLEAR_ALL,
  CLEAR_2_TO_8,
  CLEAR_3_TO_8,
  CLEAR_4_TO_8,
  CLEAR_5_TO_8,
  CLEAR_6_TO_8,
  CLEAR_7_TO_8,
} from '../types';

const INITIAL_STATE = {
  form: 'true',
  tipo: '',
  nome: '',
  cpf: '',
  telefone: '',
  email: '',
  localizacao: '',
  participacao: '',
  envolvido: '',
  tipoato: '',
  tipocrimesofrido: '',
  tipocrimepraticado: '',
  atodecorrupcao: '',
  vantagens: '',
  descricao: '',
  uf: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case INSERE_DADOS:
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };
    case CLEAR_2_TO_8:

      return {
        ...state,
        nome: '',
        cpf: '',
        telefone: '',
        email: '',
        localizacao: '',
        participacao: '',
        envolvido: '',
        tipoato: '',
        tipocrimesofrido: '',
        tipocrimepraticado: '',
        atodecorrupcao: '',
        vantagens: '',
        descricao: '',
        uf: '',
      };
    case CLEAR_3_TO_8:
      return {
        ...state,
        participacao: '',
        envolvido: '',
        tipoato: '',
        tipocrimesofrido: '',
        tipocrimepraticado: '',
        atodecorrupcao: '',
        vantagens: '',
        descricao: '',
      };
    case CLEAR_4_TO_8:
      return {
        ...state,
        tipoato: '',
        envolvido: '',
        tipocrimepraticado: '',
        tipocrimesofrido: '',
        atodecorrupcao: '',
        vantagens: '',
        descricao: '',
      };
    case CLEAR_5_TO_8:
      return {
        ...state,
        tipocrimepraticado: '',
        tipocrimesofrido: '',
        atodecorrupcao: '',
        vantagens: '',
        descricao: '',
      };
    case CLEAR_6_TO_8:

      return {
        ...state,
        atodecorrupcao: '',
        vantagens: '',
        descricao: '',
      };
    case CLEAR_7_TO_8:
      return {
        ...state,
        vantagens: '',
        descricao: '',
      };
    case CLEAR_ALL:
      return {
        form: '',
        tipo: '',
        nome: '',
        cpf: '',
        telefone: '',
        email: '',
        localizacao: '',
        participacao: '',
        envolvido: '',
        tipoato: '',
        tipocrimesofrido: '',
        tipocrimepraticado: '',
        atodecorrupcao: '',
        vantagens: '',
        descricao: '',
      };
    default:
      return { ...state };
  }
};
